export type CustomBoxShadowTokens = {
	shadow: string;
};

export default {
	shadow: '0px 0.5px 0px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)',
} satisfies CustomBoxShadowTokens;
